import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Tables } from '@/integrations/supabase/types';

export type Subscription = Tables<'subscriptions'>;

export const PLAN_LIMITS = {
  free: { properties: 1, units: 1, assistants: 0 },
  starter: { properties: 5, units: 10, assistants: 1 },
  pro: { properties: 50, units: 100, assistants: 3 },
} as const;

export const useSubscription = () => {
  const { data: subscription, isLoading } = useQuery({
    queryKey: ['subscription'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle();
      
      if (error) throw error;
      return data as Subscription | null;
    },
  });
  
  const currentPlan = subscription?.plan || 'free';
  const limits = PLAN_LIMITS[currentPlan];
  
  return { 
    subscription, 
    isLoading,
    currentPlan,
    limits,
  };
};
